@let currentStep = activeStep();
@let index = currentStepIndex();

<div class="stepper-header">
  @for (step of steps(); track step; let i = $index) {
    <div class="step" [class.active]="i === index" [class.disabled]="step.disabled()" (click)="goToStep(i)">
      <div class="step-index">{{ i + 1 }}</div>
      <div class="step-label">{{ step.title() }}</div>
    </div>
  }
</div>

<div class="stepper-body">
  @if (currentStep.content() && !currentStep.loading()) {
    <ng-container [ngTemplateOutlet]="currentStep.content() ?? null"></ng-container>
  } @else if (currentStep.loading()) {
    <mib-spinner [overlay]="true">
      @if (currentStep) {
        <p>{{ currentStep.loadingMessage() }}</p>
      }
    </mib-spinner>
  }
</div>

<div class="stepper-footer">
  <div class="stepper-footer-buttons">
    @if (displayPrevious()) {
      <mib-button (click)="doPrevious()" [disabled]="!canStepGoPrevious()">Previous</mib-button>
    }
    @if (footer()) {
      <ng-container [ngTemplateOutlet]="footer()?.content() ?? null"></ng-container>
    }
    @if (displayNext()) {
      <mib-button (click)="doNext()" [disabled]="!canStepGoNext()">Next</mib-button>
    }
  </div>
</div>
